import Enum from "./Enum";

export default Enum.create( {
	GOOGLE: "GOOGLE",
	OFFICE365: "OFFICE365",
	EMAIL: "EMAIL",
} );
